import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  blogs: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "blogs",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getBlog.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getBlog.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      blogs: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getBlog.rejected, (state, action) => ({
      ...state,
      loading: false,
      blogs: [],
      totalCount: 0,
    }));

    // //add category
    builder.addCase(Act.addBlog.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.addBlog.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.addBlog.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // edit category
    builder.addCase(Act.editBlog.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.editBlog.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.editBlog.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // delete category
    builder.addCase(Act.deleteBlog.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Act.deleteBlog.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(Act.deleteBlog.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default slice;
